import { useEffect, useState } from "react";
import { BookOpen } from "lucide-react";

export default function ArticleCover({ src, alt = "", className = "", loading = "lazy" }) {
  const [failed, setFailed] = useState(false);

  useEffect(() => setFailed(false), [src]);

  return (
    <div className={`relative aspect-video w-full overflow-hidden rounded-xl bg-gradient-to-br from-primary/15 via-secondary to-primary/5 ${className}`} data-testid="article-cover">
      {src && !failed ? (
        <img
          src={src}
          alt={alt || ""}
          width="1200"
          height="675"
          loading={loading}
          decoding="async"
          onError={() => setFailed(true)}
          className="h-full w-full object-cover"
          data-testid="article-cover-image"
        />
      ) : (
        <div className="absolute inset-0 flex items-center justify-center text-primary/45" role="img" aria-label="لا توجد صورة غلاف" data-testid="article-cover-placeholder">
          <BookOpen className="h-12 w-12 sm:h-16 sm:w-16" strokeWidth={1.25} aria-hidden="true" />
        </div>
      )}
    </div>
  );
}
